"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("./get-value");
const vote_1 = require("../../type-checking/vote");
class VoteFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, vote_1.isVoteFieldValue)(fieldValue);
        };
        this.getEmptyValue = () => (0, get_value_1.getVoteFieldEmptyValue)();
        this.isOptimizedFieldValue = (fieldValue) => (0, vote_1.isOptimizedVoteFieldValue)(fieldValue);
        this.getValueFromOptimized = (fieldValue) => {
            return {
                total_votes: fieldValue.total,
                voted: !!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.voted),
                votes: [],
            };
        };
    }
}
exports.VoteFieldValueGetter = VoteFieldValueGetter;
